import React from 'react';
import PropTypes from 'prop-types';
import ResultsModal from '../QuickQuote/ResultsModal';
import CruiseQuoteForm from './CruiseQuoteForm';
import { getFullUrl } from '../../utils/utils';
import { useQuickQuoteContext } from 'contexts/QuickQuoteContext';
import clsx from 'clsx';

const CruiseQuickQuote = ({ className, partnerConfig, flowVariant, couponCode, coupon, subDomain }) => {

  const { shipParams } = useQuickQuoteContext();
  const effectiveCoupon = coupon || couponCode;

  const submitQuickQuote = () => {
      window?.startShipppingRudderstackEvent();
      const path = `/ship?${shipParams}${effectiveCoupon ? `&coupon=${effectiveCoupon}` : ''}${subDomain ? `&partner=${subDomain}` : ''}`
      window.location.href = getFullUrl(path, window.gon?.subdomain);
  };
  return (
    <>
      <ResultsModal
        submitQuickQuote={submitQuickQuote}
      />
      
      {flowVariant === 'original' && (
        <div style={{minHeight: '988px'}} className={`
          ${className} w-full flex flex-col items-center justify-start text-center space-y-2
          bg-white border border-gray-300 px-4 lg:w-full py-6 rounded-2xl md:min-h-[988px]
        `}>
          <CruiseQuoteForm
            fromTitle={partnerConfig.fromTitle}
            toTitle={partnerConfig.toTitle}
            buttonText={partnerConfig.buttonText}
            breakText={partnerConfig.breakText}
            supportPhoneNumber={partnerConfig.supportPhoneNumber}
          />
        </div>
      )}
    </>
  );
}

CruiseQuickQuote.propTypes = {
  className: PropTypes.string,
  partnerConfig: PropTypes.object,
  flowVariant: PropTypes.string,
  couponCode: PropTypes.string,
  coupon: PropTypes.string,
  subDomain: PropTypes.string,
};
export default CruiseQuickQuote;
